import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { Observable, throwError, BehaviorSubject } from 'rxjs';
import { catchError, retry, map, tap } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { Agency_Branches } from '../Models/ActiveClasses';
import { Agency_BranchGroupsProperties } from '../Models/Agency_BranchGroupsProperties';

@Injectable({
  providedIn: 'root'
})
export class Agency_BranchGroupService {
  baseUrl = environment.baseUrl;
  backSystemUrl = environment.backSystemBaseUrl;
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  }
  constructor(private http: HttpClient) { }
  GetAgency_BranchByParent(param): Observable<Agency_Branches[]> {
    return this.http.get<Agency_Branches[]>(this.baseUrl + '/AgencyMaster/GetAgency_BranchByParent/' + param)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }
  CreateAgency_BranchGroups(obj): Observable<boolean> {
    return this.http.post<boolean>(this.baseUrl + '/Agency_BranchGroup/CreateAgency_BranchGroups', obj, this.httpOptions)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }

  UpdateAgency_BranchGroups(obj): Observable<boolean> {
    return this.http.post<boolean>(this.baseUrl + '/Agency_BranchGroup/UpdateAgency_BranchGroups', obj, this.httpOptions)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }
  GetAgency_BranchGroupByID(groupId): Observable<Agency_BranchGroupsProperties> {
    return this.http.get<Agency_BranchGroupsProperties>(this.baseUrl + '/Agency_BranchGroup/GetAgency_BranchGroupByID/' + groupId)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }

  GetAllAgencyBranchGroups(): Observable<Agency_BranchGroupsProperties[]> {
    return this.http.get<Agency_BranchGroupsProperties[]>(this.baseUrl + '/Agency_BranchGroup/GetAllAgencyBranchGroups')
      .pipe(map((data: any) => {
        // //console.log(data);
        return data;
      }), catchError(error => {  return throwError(error); }))
  }

}
